import Vue from "vue";
import Vuex from "vuex";
import Product from "@/objects/Product.js";
import UserProduct from "@/objects/UserProduct.js";
import MotifData from "@/objects/MotifData.js";
import ProductMotif from "@/objects/ProductMotif.js";
import ProductService from "@/services/ProductService.js";
import MotifService from "@/services/MotifService.js";
import Globals from "@/globals.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loadingStatus: null,
    productInfo: null,
    motifList: null,
    motifCatList: null,
    productMotifs: [],
    userProduct: null,
  },
  mutations: {
    SET_LOADING_STATUS(state, status) {
      state.loadingStatus = status;
    },
    SET_PRODUCT_INFO(state, productInfo) {
      state.productInfo = productInfo;
    },
    SET_MOTIF_LIST(state, motifList) {
      state.motifList = motifList;
    },
    SET_MOTIFCAT_LIST(state, motifCatList) {
      state.motifCatList = motifCatList;
    },
    SET_USER_PRODUCT(state, userProduct) {
      state.userProduct = userProduct;
    },
    SET_USER_PRODUCT_SIZE(state, sizeId) {
      state.userProduct.sizeId = sizeId;
    },
    SET_USER_PRODUCT_PALETTECOLOR(state, pcId) {
      state.userProduct.bgFlossId = pcId;
      },
      SET_USER_PRODUCT_BACKGROUNDIMAGE(state, biId) {
          state.userProduct.bgImageId = biId;
      },
    SET_USER_PRODUCT_OPTION(state, optionId) {
      state.userProduct.optionId = optionId;
    },
    SET_USER_PRODUCT_FINISH_STEP(state, finishStep) {
      state.userProduct.finishStep = finishStep;
    },
    ADD_PRODUCT_MOTIF(state, motif) {
      state.productMotifs.push(motif);
    },
    REMOVE_PRODUCT_MOTIF(state, pm) {
      let index = state.productMotifs.indexOf(pm);
      state.productMotifs.splice(index, 1);
    },
    EDIT_PRODUCT_MOTIF(state, pms) {
      let index = state.productMotifs.indexOf(pms.originalPm);

      state.productMotifs.splice(index, 1, pms.updatedPm);
    },
  },
  actions: {
    async fillProductInfo(context) {
          context.commit("SET_LOADING_STATUS", "loading product info");
          let ptId = Globals.getProductType();
          var response = await ProductService.getProduct(ptId);
          
          context.commit("SET_LOADING_STATUS", "");
          context.commit("SET_PRODUCT_INFO", new Product(response.data));
    },
    async fillMotifList(context) {
      if (context.state.motifList == null) {
        context.commit("SET_LOADING_STATUS", "loading motifs");
        var response = await MotifService.getMotifs();
        context.commit("SET_LOADING_STATUS", "");
        context.commit(
          "SET_MOTIF_LIST",
          MotifService.getMotifListFromJson(response.data)
        );
        context.commit(
          "SET_MOTIFCAT_LIST",
          MotifService.getMotifCatListFromJson(response.data)
        );

          var pGuid = Globals.getDesignGuid();
        if (pGuid != null) await context.dispatch("loadProduct", pGuid);
        else {
          let defaultUserProduct = new UserProduct();

          //todo kat : remove hard coded defaults
            defaultUserProduct.productTypeId = context.state.productInfo.productId;
            defaultUserProduct.optionId = context.state.productInfo.options[0].productOptions[0].productOptionId;
            //defaultUserProduct.sizeId = 49;//context.state.productInfo.sizes.find(({ sizeIsDefault }) => sizeIsDefault == true).sizeId;
            //if (context.state.productInfo.productId == 7) {
            defaultUserProduct.sizeId = context.state.productInfo.sizes.find(({ sizeIsDefault }) => sizeIsDefault == true).sizeId;
            defaultUserProduct.bgImageId = 0;
           //}
             // 482;
            defaultUserProduct.productLocation = Globals.getProductLocation();
            defaultUserProduct.bgFlossId = defaultUserProduct.productLocation == 2 ? 468 : 797;
            defaultUserProduct.finishStep = Globals.getInitialFinishStep();
            defaultUserProduct.originKitId = 0;
          context.commit("SET_USER_PRODUCT", defaultUserProduct);
        }
      }
    },
    async loadProduct(context, productGuid) {
      context.commit("SET_LOADING_STATUS", "loading product");
      var response = await ProductService.loadProduct(productGuid); 
        context.commit("SET_LOADING_STATUS", "");
      var loadedProduct = new UserProduct(response.data);
        context.commit("SET_USER_PRODUCT", loadedProduct);

      loadedProduct.productLocation = Globals.getProductLocation();
        loadedProduct.finishStep = Globals.getInitialFinishStep(false);
        loadedProduct.kitId = Globals.kitId();
        if (!Globals.isModProduct()) {
            loadedProduct.originKitId = Globals.okitId();
        }
      for (let m of loadedProduct.motifs) {
        let motif = context.state.motifList.find(
          ({ motifId }) => motifId == m.motifData.motifId
        );
        let pmId = Globals.getUniquePMId(context.state.productMotifs);
        if (m.customMotifInputs) {
          let pm = new ProductMotif(
            MotifData.clone(motif),
            m.customMotifInputs,
            pmId
          );
          pm.motifData.motifImageData = m.motifData.motifImageData;
          pm.motifData.motifWidth = m.motifData.motifWidth;
          pm.motifData.motifHeight = m.motifData.motifHeight;
          context.commit("ADD_PRODUCT_MOTIF", pm);
        } else {
          let pm = new ProductMotif(motif, null, pmId);
          context.commit("ADD_PRODUCT_MOTIF", pm);
        }
        }
        console.log(loadedProduct);
      },
      setLoadingStatus(context, status) {
          context.commit("SET_LOADING_STATUS", status);
      },
    addMotifToProduct(context, motif) {
      context.commit("SET_LOADING_STATUS", "adding motif");
      if (!Globals.checkWidth(context, null, motif)) return false;
      let pmId = Globals.getUniquePMId(context.state.productMotifs);
      let pm = new ProductMotif(motif, null, pmId);
      context.commit("ADD_PRODUCT_MOTIF", pm);
      context.commit("SET_LOADING_STATUS", "");
      return pm;
    },
    motifFits(context, motif) {
      return Globals.checkWidth(context, null, motif);
    },
    removeMotifFromProduct(context, pm) {
      context.commit("REMOVE_PRODUCT_MOTIF", pm);
      return pm;
    },
    addCustomMotifToProduct(context, customMotif) {
      let pmId = Globals.getUniquePMId(context.state.productMotifs);
      let pm = new ProductMotif(
        customMotif.motif,
        customMotif.motifInputs,
        pmId
      );
      context.commit("ADD_PRODUCT_MOTIF", pm);
    },
    editCustomProductMotif(context, pms) {
      context.commit("EDIT_PRODUCT_MOTIF", pms);
    },
    setUserProductSize(context, sizeId) {
      context.commit("SET_USER_PRODUCT_SIZE", sizeId);
    },
    setUserProductPaletteColor(context, pcid) {
      context.commit("SET_USER_PRODUCT_PALETTECOLOR", pcid);
      },
      setUserProductBackgroundImage(context, biid) {
          context.commit("SET_USER_PRODUCT_BACKGROUNDIMAGE", biid);
      },
    setUserProductOption(context, optionId) {
      context.commit("SET_USER_PRODUCT_OPTION", optionId);
    },
      setUserProductFinishStep(context, finishStep) {
          context.commit("SET_USER_PRODUCT_FINISH_STEP", finishStep);
      },
      finishProduct(context, canvasOnly) {
          if (Globals.getFinishStep() == 3) {
              context.commit("SET_LOADING_STATUS", "Updating Motifs");
          } else
              context.commit("SET_LOADING_STATUS", (canvasOnly) ? "Creating Canvas" : "Creating Product");
          context.state.userProduct.motifs = context.state.productMotifs;
          var response = ProductService.createProduct(
              context.state.userProduct
          ).then((response) => {

              context.commit("SET_LOADING_STATUS", (canvasOnly) ? "Redirecting to Canvas" : "Redirecting to Product");

              if (context.state.userProduct.productLocation == 2) {
                  console.log("SFY Redirect");
                  window.parent.location.href = response.data.item2;
              }
              else {
                  let redirectUrl = response.data.item2;
                  if (context.state.userProduct.finishStep == 3) {
                      // updatemotifskit flow: send admin back to the Blazor kit-detail
                      // page (NPNET); the .aspx route is dead in the migrated stack.
                      redirectUrl = "/admin/kit-detail?kid=" + Globals.kitId();
                  }
                  else if (canvasOnly || context.state.userProduct.finishStep == 1) {
                      redirectUrl = redirectUrl.replace("custom/product.aspx", "custom/canvas.aspx")
                                               .replace("/custom/product/", "/custom/canvas/")
                                               .replace("custom/product?", "custom/canvas?");
                  }
                  // Cart-edit round-trip: re-append cpid/oid the NPNET CartEditController
                  // threaded through the designer URL so CustomDetail loads in cart-edit
                  // mode. Whitelisted external embeds (brewsterbelt.com, Etsy) never pass
                  // these and so are unaffected.
                  const cpid = Globals.cartProductId();
                  const oid = Globals.adminOrderId();
                  if (cpid || oid) {
                      const sep = redirectUrl.indexOf("?") > -1 ? "&" : "?";
                      const parts = [];
                      if (cpid) parts.push("cpid=" + cpid);
                      if (oid) parts.push("oid=" + oid);
                      redirectUrl = redirectUrl + sep + parts.join("&");
                  }
                  location.href = Globals.appRoot + redirectUrl;
              }
          });
          return false;
    },
  },
  modules: {},
});
